import {
    StoreSwitcher as SourceStoreSwitcher
} from 'SourceComponent/StoreSwitcher/StoreSwitcher.component';

import './StoreSwitcher.override.style';

/** @namespace Elganso/Component/StoreSwitcher/Component */
export class StoreSwitcherComponent extends SourceStoreSwitcher {
    renderStoreYB(item) {
        const { onYBStoreItemClick, formateaCodigoStoreView } = this.props;
        const { value, storeLinkUrl } = item;

        return (
            <div
              key={ value }
              block="StoreSwitcher"
              elem="YBStoreItem"
              onClick={ () => onYBStoreItemClick(value, storeLinkUrl) } // FALTA QUE FUNCIONE ESTE
              onKeyUp={ () => {} }
            >
                <span>{ formateaCodigoStoreView(value) } -</span>
            </div>
        );
    }

    renderYBStoreSwitcher() {
        const { storeList, onYBStoreItemClick } = this.props;

        return (
            <div block="StoreSwitcher" elem="YBStoreList">
                { storeList.map(this.renderStoreYB.bind(this)) }
                <div
                  block="StoreSwitcher"
                  elem="YBStoreItem"
                  onClick={ () => onYBStoreItemClick('languages', null) }
                  onKeyUp={ () => {} }
                >
                    <span>{ __('Others') }</span>
                </div>
            </div>
        );
    }

    render() {
        const { storeList, device, isMenuYB } = this.props;

        if (isMenuYB) {
            return this.renderYBStoreSwitcher();
        }
        if (storeList.length <= 1) {
            return null;
        }

        if (device.isMobile) {
            return this.renderMobileStoreSwitcher();
        }

        return this.renderDesktopStoreSwitcher();
    }
}

export default StoreSwitcherComponent;
